import { Components } from 'src/components';
import { setComponentAttributes } from 'shared/storybook-utils';

export default {
  title: 'Components/Input',
  component: 'a1-input',
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: ' Form Component - Input field partial.',
      },
    },
    layout: 'centered',
  },
};

const elementName = 'a1-input';

const Template = (args: Components.A1Input): HTMLElement => {
  const elComponent = document.createElement(elementName);

  Object.entries(args).forEach(([key, value]) => {
    setComponentAttributes({ element: elComponent, key, value });
  });

  return elComponent;
};

export const Default: Story<Components.A1Input> = Template.bind({});
Default.args = {
  inputId: 'input-id',
  value: 'Input',
};

export const Placeholder: Story<Components.A1Input> = Template.bind({});
Placeholder.args = {
  ...Default.args,
  value: '',
  placeholder: 'Input placeholder',
};

export const Prefix: Story<Components.A1Input> = Template.bind({});
Prefix.args = {
  ...Default.args,
  inputPrefix: '$',
};

export const Postfix: Story<Components.A1Input> = Template.bind({});
Postfix.args = {
  ...Default.args,
  inputPostfix: '%',
};

export const PrefixAndPostfix: Story<Components.A1Input> = Template.bind({});
PrefixAndPostfix.args = {
  ...Default.args,
  inputPrefix: '$',
  inputPostfix: '%',
};

export const ReadOnly: Story<Components.A1Input> = Template.bind({});
ReadOnly.storyName = 'Read-Only';
ReadOnly.args = {
  ...Default.args,
  value: 'Read-only',
  readonly: true,
};

export const Critical: Story<Components.A1Input> = Template.bind({});
Critical.args = {
  ...Default.args,
  critical: true,
};

export const Disabled: Story<Components.A1Input> = Template.bind({});
Disabled.args = {
  ...Default.args,
  value: 'Input disabled',
  disabled: true,
};

export const Password: Story<Components.A1Input> = Template.bind({});
Password.args = {
  ...Default.args,
  type: 'password',
  value: 'ExamplePassword',
};

export const Number: Story<Components.A1Input> = Template.bind({});
Number.args = {
  ...Default.args,
  type: 'number',
  value: '999',
};
